import React from 'react';
import {
    Button,
    Flex,
    pxToRem,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import * as S from './ArticleAuthBanner.style';
import { CustomArrowRight } from '@archipro-design/icons';

interface ArticleAuthBannerProps {
    showAutModal: () => void;
    bannerRef?: React.Ref<HTMLDivElement>;
}

const ArticleAuthBanner = ({
    showAutModal,
    bannerRef,
}: ArticleAuthBannerProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();

    const handleOpenAuthModal = () => {
        showAutModal();
    };

    return (
        <Flex className={css(S.ArticleAuthBannerContainer)} ref={bannerRef}>
            <Flex column className={css(S.ArticleAuthBannerContentContainer)}>
                <Flex className={css(S.ArticleAuthBannerText)}>
                    Sign up to read this article for free
                </Flex>
                <Flex
                    className={css(S.ArticleAuthBannerButtonGroup)}
                    gap="space-10"
                >
                    <Button
                        color="dark"
                        variant={'contained'}
                        size={16}
                        onClick={handleOpenAuthModal}
                        variables={{
                            iconPadding: 0,
                            buttonSize16IconXMargin: pxToRem(5),
                        }}
                        iconAfter={
                            mobile ? (
                                <CustomArrowRight className="arrow-icon" />
                            ) : undefined
                        }
                    >
                        {mobile ? 'SIGN UP / LOG IN' : 'SIGN UP'}
                    </Button>
                    {!mobile && (
                        <Button
                            color="white"
                            variant={'contained'}
                            onClick={handleOpenAuthModal}
                        >
                            LOG IN
                        </Button>
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
};

export default ArticleAuthBanner;
